import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'

import { selectEditSignupWithExternals } from '../../modules/signupEdit/selectors'

import create from './create'
import setRealm from './setRealm'
import setSiteContact from './setSiteContact'
import update from './update'

export default function* advanceToDetail(apis) {
  const state = yield effects.select()
  const signupWithExternals = yield effects.call(
    selectEditSignupWithExternals,
    state,
  )

  let success
  if (signupWithExternals.signup.id) {
    success = yield effects.call(
      update,
      apis,
      signupWithExternals.signup,
      state.signupEdit.get('meta'),
      false,
    )
  } else {
    success = yield effects.call(create, apis, signupWithExternals.signup)
  }

  if (!success) {
    return
  }

  yield effects.fork(setSiteContact)
  yield effects.fork(setRealm)

  yield effects.put.resolve(pushPath('/detail'))

  yield effects.call(() => document.getElementById('wrapper').scrollIntoView())
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/advanceToDetail.js